import React, {useMemo} from "react";
import IMG from "../../constants/image";
import {Link, useLocation} from "react-router-dom";
import {PATH} from "../../constants";

const columns = [
    {
        id: "home",
        title: "Tổng quan",
        icon: IMG.icon.homeSeller,
        iconActive: IMG.icon.homeSellerActive,
        to: PATH.HOME
    },
    {
        id: "products",
        title: "Sản phẩm",
        icon: IMG.icon.boxBlack,
        iconActive: IMG.icon.boxGreen,
        to: PATH.MANAGING_PRODUCT
    },
    {
        id: "order",
        title: "Đơn hàng",
        icon: IMG.icon.clipboardList,
        iconActive: IMG.icon.clipboardListActive,
        to: PATH.MANAGING_ORDER
    },
    {
        id: "account",
        title: "Tài khoản",
        icon: IMG.icon.userBlack,
        iconActive: IMG.icon.userGreen,
        to: PATH.ACCOUNT_SETTING
    },
];

const FooterMobile = () => {
    const location = useLocation();
    const {pathname} = location || {};

    const activeMenu = useMemo(() => {
        if (pathname === PATH.HOME) return columns[0];
        // Check if pathname includes any of the base paths
        if (pathname) {
            return columns.find(column => {
                if (column.to === PATH.HOME) return pathname === PATH.HOME;
                return pathname.startsWith(column.to);
            });
        }
    }, [pathname]);

    if ((pathname).includes(PATH.LOGIN) || (pathname).includes(PATH.ONBOARDING) || (pathname).includes(PATH.NOTIFICATION)) {
        return null
    }

    const handleColumnClick = (column) => {
        const element = document.getElementById(column?.id);
        if (element) {
            element.scrollIntoView({behavior: "smooth"});
        }
    };

    if (pathname === PATH.CHANGE_PASSWORD ||
        pathname === PATH.STORE_INFO ||
        pathname === PATH.ADDRESS ||
        pathname === PATH.BUYER_MANAGEMENT_CART_DETAIL ||
        pathname === PATH.SHARE ||
        pathname === PATH.CREATE_PRODUCT ||
        pathname.startsWith(PATH.EDIT_PRODUCT)) return null;
    return (
        <footer className="md:hidden fixed bottom-0 left-0 right-0 bg-[#FAFAFC] shadow-lg h-[80px]">
            <div
                className="flex md:flex-row justify-around items-center py-4 shadow-tl-lg shadow-[0_-5px_4px_rgba(0,0,0,0.05)] rounded-tl-2xl rounded-tr-3xl">
                {columns.map((column) => (
                    <Link className='cursor-pointer' to={column.to} key={column.to}>
                        <button
                            key={column}
                            onClick={() => handleColumnClick(column)}
                            className={`flex text-xs flex-col items-center w-full md:w-auto px-4 transition-colors duration-300 ease-in-out ${
                                activeMenu?.id === column.id
                                    ? "text-[#197D55]"
                                    : ""
                            }`}
                            aria-label={column.title}
                        >
                            <img className='w-6' src={activeMenu?.id === column.id ? column.iconActive : column.icon}
                                 alt='icon'/>
                            <span>{column.title}</span>
                        </button>
                    </Link>
                ))}
            </div>
        </footer>
    );
};

export default FooterMobile;
